import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1b5a0b87"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "table table-hover table-striped" };
const _hoisted_2 = {
    class: "p-2",
    style: { "height": "44px" }
};
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", {
    width: "50",
    class: "time-col p-2"
}, " ", -1));
const _hoisted_4 = ["colspan"];
const _hoisted_5 = { key: 0 };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("th", { class: "p-2" }, " ", -1));
const _hoisted_7 = { class: "time-col" };
const _hoisted_8 = ["colspan"];
import { midnightOfDate, timeToString } from '@/classes/timestamps';
import NewScheduleModal from './NewScheduleModal.vue';
import TeamSlot from './TeamSlot.vue';
import EditButton from './EditButton.vue';
import EditPanel from './EditPanel.vue';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { Button, Icon } from '../UI';
import { cloneDeep } from 'lodash';
import { UndoHandler } from '@/classes/undoHandler';
import useScheduler from '@/compositions/useScheduler';
import { useToast } from 'vue-toastification';
import { SchedulePriority } from '@/types/rooms';
import TeamBadge from '../UI/TeamBadge/TeamBadge.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        groups: null,
        day: null
    },
    emits: ["onSave"],
    setup(__props, { emit: emits }) {
        const props = __props;
        const fixSchedule = ref(true);
        const updateCount = ref(0);
        const editStartTime = ref(null);
        const localGroups = ref(cloneDeep(props.groups));
        watch(props.groups, () => {
            localGroups.value = cloneDeep(props.groups);
        });
        const editMode = ref(false);
        const undoManager = ref(new UndoHandler());
        const scheduleGroup = ref(null);
        watch(editMode, () => {
            fixSchedule.value = true;
        });
        const editGroup = (slot, groupId) => {
            undoManager.value.add(localGroups.value);
            editStartTime.value = slot;
            scheduleGroup.value = groupId;
        };
        const cancelSchedule = () => {
            editMode.value = false;
            undoManager.value.clear();
        };
        const addPause = async (groupId) => {
            const newGroups = cloneDeep(localGroups.value);
            fixSchedule.value = false;
            const group = newGroups[groupId];
            group.pause_preferences = new Array(group.num_slots + 1).fill(SchedulePriority.Minor);
            const center_slot = Math.floor(group.pause_preferences.length / 2);
            if (center_slot - 1 >= 0) {
                group.pause_preferences[center_slot - 1] = SchedulePriority.Normal;
            }
            group.pause_preferences[center_slot] = SchedulePriority.Important;
            if (center_slot + 1 < group.pause_preferences.length) {
                group.pause_preferences[center_slot + 1] = SchedulePriority.Normal;
            }
            const settings = newGroups[groupId].scheduler_settings;
            await onUpdateSchedule({ newGroups, settings });
        };
        const addSlot = async (groupId, nrSlots) => {
            localGroups.value[groupId].num_slots += nrSlots;
            const newGroups = cloneDeep(localGroups.value);
            fixSchedule.value = false;
            const settings = newGroups[groupId].scheduler_settings;
            await onUpdateSchedule({ newGroups, settings });
        };
        const moveSlots = async (groupId, delta) => {
            localGroups.value[groupId].start_time += delta * 20 * 60;
            const newGroups = cloneDeep(localGroups.value);
            await onUpdateSchedule({ newGroups, settings: newGroups[groupId].scheduler_settings });
        };
        const removeSchedule = (groupId) => {
            undoManager.value.add(localGroups.value);
            localGroups.value[groupId].start_time = null;
            for (const teamId in localGroups.value[groupId].teams) {
                localGroups.value[groupId].teams[teamId].schedule = [];
            }
        };
        const undo = () => {
            localGroups.value = undoManager.value.undo(localGroups.value);
        };
        const redo = () => {
            localGroups.value = undoManager.value.redo(localGroups.value);
        };
        const save = () => {
            emits('onSave', localGroups.value);
            editMode.value = false;
            undoManager.value.clear();
        };
        const { getSchedule } = useScheduler();
        const toast = useToast();
        const closeModal = () => scheduleGroup.value = null;
        const verifySpiderRoom = (schedule, team) => {
            toast.clear();
            if (schedule.includes('spiderroom') && team.members.length < 4) {
                toast.error('SpiderRoom gepland bij team ' + team.name + ' dat te weinig deelnemers heeft', { timeout: 0 });
            }
        };
        const onUpdateSchedule = async (args) => {
            const scheduleUpdate = await getSchedule({
                groups: Object.values(args.newGroups),
                fixed_schedule: fixSchedule.value,
                settings: args.settings
            });
            if (['optimal', 'feasible'].includes(scheduleUpdate.status)) {
                Object.values(args.newGroups)
                    .flatMap(group => Object.values(group.teams))
                    .filter(team => scheduleUpdate.changed_team_ids.includes(team.id))
                    .forEach(team => {
                    var _a, _b;
                    team.schedule = (_b = (_a = scheduleUpdate.teams.find(t => t.id === team.id)) === null || _a === void 0 ? void 0 : _a.schedule) !== null && _b !== void 0 ? _b : [];
                    verifySpiderRoom(team.schedule, team);
                });
                console.log('Update teams', args.newGroups);
                toast.success('Valid Schedule found');
                undoManager.value.add(args.newGroups);
                updateCount.value++;
                localGroups.value = args.newGroups;
                scheduleGroup.value = null;
            }
            else {
                fixSchedule.value = false;
                toast.error("No valid schedule found, click again to try to update other teams as well");
            }
        };
        const timeslots = computed(() => {
            console.log('recomputing timeslots');
            const slots = [];
            const startDate = midnightOfDate(props.day);
            const startTimestamp = startDate.getTime() + 10 * 60 * 1000; // Add 10 minutes after midnight
            for (let index = 0; index <= 24 * 3; index++) {
                const date = new Date(startTimestamp + index * 20 * 60 * 1000);
                const classes = [];
                if (now.value >= date && now.value < new Date(date.getTime() + 20 * 60 * 1000))
                    classes.push("currentTimeSlot");
                slots.push({
                    date,
                    name: timeToString(date),
                    classes
                });
            }
            return slots;
        });
        const now = ref(new Date());
        let timer;
        onMounted(() => {
            timer = window.setInterval(() => {
                now.value = new Date();
            }, 10 * 1000);
        });
        onUnmounted(() => {
            clearInterval(timer);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("table", _hoisted_1, [
                    _createElementVNode("thead", _hoisted_2, [
                        _hoisted_3,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localGroups.value, (group, groupId) => {
                            var _a, _b, _c;
                            return (_openBlock(), _createElementBlock("th", {
                                key: groupId,
                                colspan: Object.keys(group.teams).length,
                                class: "p-2 header-group"
                            }, [
                                _createTextVNode(_toDisplayString(group.name) + " ", 1),
                                (group.start_time !== null)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, " (" + _toDisplayString(new Date(group.start_time * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })) + ") ", 1))
                                    : _createCommentVNode("", true),
                                (group.pause_preferences.length === 0 && editMode.value)
                                    ? (_openBlock(), _createBlock(_unref(Button), {
                                        key: 1,
                                        onClick: ($event) => (addPause(groupId))
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Icon), {
                                                name: "pause-circle",
                                                title: "Voeg een pauze toe"
                                            })
                                        ]),
                                        _: 2
                                    }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true),
                                (editMode.value)
                                    ? (_openBlock(), _createBlock(_unref(Button), {
                                        key: 2,
                                        onClick: ($event) => (addSlot(groupId, 1))
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Icon), {
                                                name: "plus",
                                                title: "Voeg een slot toe"
                                            })
                                        ]),
                                        _: 2
                                    }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true),
                                (editMode.value)
                                    ? (_openBlock(), _createBlock(_unref(Button), {
                                        key: 3,
                                        onClick: ($event) => (addSlot(groupId, -1))
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Icon), {
                                                name: "minus",
                                                title: "Verwijder een slot"
                                            })
                                        ]),
                                        _: 2
                                    }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true),
                                (editMode.value)
                                    ? (_openBlock(), _createBlock(_unref(Button), {
                                        key: 4,
                                        onClick: ($event) => (moveSlots(groupId, -1))
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Icon), {
                                                name: "arrow-up",
                                                title: "Verplaats slot omhoog"
                                            })
                                        ]),
                                        _: 2
                                    }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true),
                                (editMode.value)
                                    ? (_openBlock(), _createBlock(_unref(Button), {
                                        key: 5,
                                        onClick: ($event) => (moveSlots(groupId, 1))
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Icon), {
                                                name: "arrow-down",
                                                title: "Verplaats slot omlaag"
                                            })
                                        ]),
                                        _: 2
                                    }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true),
                                (editMode.value && ((_c = (_b = (_a = Object.values(group.teams)[0]) === null || _a === void 0 ? void 0 : _a.schedule) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0)
                                    ? (_openBlock(), _createBlock(_unref(Button), { key: 6 }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Icon), {
                                                onClick: ($event) => (removeSchedule(groupId)),
                                                name: "trash",
                                                title: "Verwijder schema"
                                            }, null, 8, ["onClick"])
                                        ]),
                                        _: 2
                                    }, 1024))
                                    : _createCommentVNode("", true)
                            ], 8, _hoisted_4));
                        }), 128))
                    ]),
                    _createElementVNode("thead", null, [
                        _hoisted_6,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localGroups.value, (group) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(group.teams), (teamId) => {
                                    var _a;
                                    return (_openBlock(), _createElementBlock("th", {
                                        key: `header_${group.name}_${teamId}`,
                                        class: "p-2"
                                    }, [
                                        _createTextVNode(_toDisplayString(group.teams[teamId].name) + " ", 1),
                                        _createVNode(TeamBadge, {
                                            rfid: (_a = group.teams[teamId].members[0]) === null || _a === void 0 ? void 0 : _a.rfid,
                                            size: 1
                                        }, null, 8, ["rfid"])
                                    ]));
                                }), 128))
                            ], 64));
                        }), 256))
                    ]),
                    _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timeslots), (slot) => {
                            return (_openBlock(), _createElementBlock("tr", {
                                key: slot.name,
                                class: _normalizeClass(slot.classes)
                            }, [
                                _createElementVNode("th", _hoisted_7, _toDisplayString(slot.name), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localGroups.value, (group, groupId) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                        (group.start_time === null)
                                            ? (_openBlock(), _createElementBlock("td", {
                                                key: `group_${groupId}_${slot}`,
                                                colspan: Object.keys(group.teams).length,
                                                class: "text-center"
                                            }, [
                                                (editMode.value)
                                                    ? (_openBlock(), _createBlock(_unref(Button), {
                                                        key: 0,
                                                        variant: "light",
                                                        onClick: ($event) => (editGroup(slot.date, groupId))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(Icon), { name: "plus" })
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["onClick"]))
                                                    : _createCommentVNode("", true)
                                            ], 8, _hoisted_8))
                                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(Object.keys(group.teams), (teamId) => {
                                                return (_openBlock(), _createBlock(TeamSlot, {
                                                    key: `group_${groupId}_${slot}_${teamId}_${updateCount.value}`,
                                                    group: group,
                                                    allGroups: localGroups.value,
                                                    teamId: teamId,
                                                    timeslot: slot.date,
                                                    editMode: editMode.value
                                                }, null, 8, ["group", "allGroups", "teamId", "timeslot", "editMode"]));
                                            }), 128))
                                    ], 64));
                                }), 256))
                            ], 2));
                        }), 128))
                    ])
                ]),
                _createVNode(EditButton, {
                    modelValue: editMode.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((editMode).value = $event))
                }, null, 8, ["modelValue"]),
                (editMode.value)
                    ? (_openBlock(), _createBlock(EditPanel, {
                        key: 0,
                        undoManager: undoManager.value,
                        onOnCancel: cancelSchedule,
                        onOnUndo: undo,
                        onOnRedo: redo,
                        onOnSave: save
                    }, null, 8, ["undoManager"]))
                    : _createCommentVNode("", true),
                (scheduleGroup.value !== null)
                    ? (_openBlock(), _createBlock(NewScheduleModal, {
                        key: 1,
                        modelValue: localGroups.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((localGroups).value = $event)),
                        editGroupId: scheduleGroup.value,
                        startTime: editStartTime.value,
                        onClose: closeModal,
                        onSubmit: onUpdateSchedule
                    }, null, 8, ["modelValue", "editGroupId", "startTime"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
